export default __webpack_public_path__ + "static/media/Trade_Gothic_LT_Bold.bb7f3776.woff2";